module.exports = __webpack_public_path__ + "media/images/admin/icons/cloud-drizzle-02fb46d6647033c0f275dd18a3ce14e3.svg";